import { render } from "./deptMng.vue?vue&type=template&id=54e0aaae"
import script from "./deptMng.vue?vue&type=script&lang=js"
export * from "./deptMng.vue?vue&type=script&lang=js"

import "./deptMng.vue?vue&type=style&index=0&id=54e0aaae&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__